import React, {useEffect, useRef, useState} from 'react';
// import {useHistory} from 'react-router-dom';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import TableHeader from '../../../common/components/ItemTable/TableHeader';
import Loading from '../../../common/components/Loading/Loading';
import {connect} from 'react-redux';
import actions from '../../../redux/actions';
import PropTypes from 'prop-types';
import TableRow from '../../../common/components/ItemTable/TableRow';
import ListPaginator from '../../../common/components/ListPaginator/ListPaginator';
import {CSVLink} from 'react-csv';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import {CustomSelect} from '../../../common/components/CustomInputs/CustomInputs';
import {deleteExtraSpaces} from '../../../utils/util';
import './AmountList.scss';
import ExcelDownloadButton from '../../../common/components/ExcelDownloadButton/ExcelDownloadButton';


const AmountList = (props) => {
    const {
        name,
        title,
        getAmount,
        amountList,
        getAmountListState,
        getAllAmountsToDownload,
        setListConfig,
        role,
        amountListToDownload,
        branches,
        getBranchesState,
        getBranches,
        cleanBranches,
        cleanAmountListState,
    } = props;

    const [listdata, setListData] = useState([]);
    // super admin vea prestador tambien

    const [items, setItems] = useState([]);
    const [pageQuantity, setPageQuantity] = useState(Math.ceil(amountList?.totalCount));
    const [branchesOptions, setBranchesOptions] = useState([]);
    const [provider, setProvider] = useState(undefined);
    const [currentPage, setCurrentPage] = useState(1);

    const isInitialMount = useRef(true);

    const headersDict = {
        'PROVIDER_ADMIN': [['Código', 'Descripción', 'Valor', 'Prestador', 'Id prestación']],
        'ADMIN': [['Código', 'Descripción', 'Valor', 'Prestador', 'Id prestación', 'Id prestador']],
    };


    useEffect(() => {
        switch (role) {
            case 'PROVIDER_ADMIN':
                setListData([
                    {title: 'DESCRIPCIÓN', att: 'description', width: '40%'},
                    {title: 'CODIGO', att: 'code', width: '30%'},
                    {title: 'VALOR FIJADO', att: 'value', width: '30%'}]);
                getAllAmountsToDownload();
                getAmount();
                break;
            case 'ADMIN':
                setListData([
                    {title: 'ID', att: 'id', width: '10%'},
                    {title: 'DESCRIPCIÓN', att: 'description', width: '30%'},
                    {title: 'CODIGO', att: 'code', width: '20%'},
                    {title: 'VALOR FIJADO', att: 'value', width: '20%'}]);
                getBranches();
                break;
        }
    }, []);

    useEffect(() => {
        setItems(amountList.amounts);
        setPageQuantity(Math.ceil(amountList?.totalCount / amountList?.itemsPerPage));
    }, [amountList, getAmountListState.success]);

    useEffect(() => {
        if (!isInitialMount.current) {
            setListConfig({
                list: 'amountListConfig',
                config: {page: currentPage},
            });
            getAmount();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);


    useEffect(() => {
        if (!provider) {
            cleanBranches();
            cleanAmountListState();
        } else {
            setListConfig({
                list: 'amountListConfig',
                config: {page: currentPage, providerName: provider},
            });
            getAmount();
            getAllAmountsToDownload();
        }
    }, [provider]);


    useEffect(() => {
        if (currentPage > pageQuantity) setCurrentPage(pageQuantity);
        // eslint-disable-next-line
    }, [amountList]);


    useEffect(() => {
            setBranchesOptions(branches?.map((branch) => {
                return {value: branch.fullName, label: deleteExtraSpaces(branch.fullName)};
            }));
        }
        , [branches, getBranchesState.success]);


    return (
        <div className={window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                    <div>
                        {amountListToDownload.length > 0 ?
                            <ExcelDownloadButton data={amountListToDownload} headers={headersDict[role]}
                                                 fileName={`GRILLA_DE_VALORES:${role === 'ADMIN' ? 'TODAS' : name}-
                                                 FECHA DE EMISION:${new Date().toLocaleDateString()}`}/> :
                            <Ebutton classNameButton={'disabled'} disabled={true} text={'CARGANDO...'}/>
                        }
                    </div>
                </div>
                <div className="provider-selector-container">
                    {role === 'ADMIN' &&
                        <div className="eu-div-input lbl-container">
                            <text className="eu-text-l eu-f-label mb-05rem">Prestador</text>
                            {!provider && <text className={'eu-text-small mb-05rem'}> Seleccione un prestador </text>}
                            <CustomSelect
                                name="provider"
                                className="eu-input-l eu-select width-100"
                                onChange={(value) => setProvider(value?.value)}
                                value={provider}
                                options={branchesOptions}
                                disabled={branchesOptions?.length === 0 || getBranchesState.loading}
                                isSearchable={true}
                                isClearable={true}
                            />
                        </div>
                    }
                </div>
                <div className="ul-div-sect-table">
                    {getAmountListState.success ?
                        <table className="ul-div-table">
                            <TableHeader listData={listdata}/>
                            <tbody>
                            {
                                items?.length <= 0 ?
                                    <tr>
                                        <td colSpan={100}><CustomAlert text='valores'/></td>
                                    </tr> :
                                    items?.map((item, index) =>
                                        <TableRow key={index} listData={listdata} data={item}/>,
                                    )
                            }
                            </tbody>
                        </table> :
                        getAmountListState.loading ?
                            <Loading className="ul-div-sect-table"/> : getAmountListState.error &&
                            <CustomAlert text={'Grilla de valores' || String(getAmountListState.error)}
                                         severity='error'/>

                    }
                </div>
                <div className="ul-div-bottom">
                    <ListPaginator pageQuantity={pageQuantity} currentPage={amountList.page}
                                   setCurrentPage={setCurrentPage} initInOne={true}
                    />

                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    amountList: state.home.amountList,
    getAmountListState: state.home.getAmountListState,
    role: state.login.userInfo.role.name,
    amountListToDownload: state.home.amountListToDownload,
    branches: state.home.branches,
    getBranchesState: state.home.getBranchesState,
});


const mapDispatchToProps = (dispatch) => ({
    getAmount: () => dispatch(actions.home.getAmountListRequest()),
    getAllAmountsToDownload: () => dispatch(actions.home.getAllAmountsToDownloadRequest()),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanAmountListState: () => dispatch(actions.home.cleanAmountListState()),
});

AmountList.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    getAmount: PropTypes.func,
    amountList: PropTypes.object,
    getAmountListState: PropTypes.object,
    amountListToDownload: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(AmountList);

